import { render, staticRenderFns } from "./HeadingWidget.vue?vue&type=template&id=1729c729&scoped=true"
import script from "./HeadingWidget.vue?vue&type=script&lang=js"
export * from "./HeadingWidget.vue?vue&type=script&lang=js"
import style0 from "./HeadingWidget.vue?vue&type=style&index=0&id=1729c729&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1729c729",
  null
  
)

export default component.exports